import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { MockupSection } from './components/MockupSection';
import { HookSection } from './components/HookSection';
import { ForWho } from './components/ForWho';
import { ContentTomos } from './components/ContentTomos';
import { Bonos } from './components/Bonos';
import { ValueStack } from './components/ValueStack';
import { PricingCTA } from './components/PricingCTA';
import { Garantia } from './components/Garantia';
import { Testimonios } from './components/Testimonios';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen bg-brand-black text-brand-gray-text font-opensans selection:bg-brand-red selection:text-white" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <Hero data-id="element-2" />
      <MockupSection data-id="element-3" />
      <HookSection data-id="element-4" />
      <ForWho data-id="element-5" />
      <ContentTomos data-id="element-6" />
      <Bonos data-id="element-7" />
      <ValueStack data-id="element-8" />
      <PricingCTA data-id="element-9" />
      <Garantia data-id="element-10" />
      <Testimonios data-id="element-11" />
      <FAQ data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Footer data-id="element-14" />
      <PurchasePopup data-id="element-15" />
    </div>;
}